export default "__VITE_ASSET__6d124652__"